import { render, staticRenderFns } from "./PersonItem.vue?vue&type=template&id=5e48ae74&scoped=true&"
import script from "./PersonItem.vue?vue&type=script&lang=js&"
export * from "./PersonItem.vue?vue&type=script&lang=js&"
import style0 from "./PersonItem.vue?vue&type=style&index=0&id=5e48ae74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e48ae74",
  null
  
)

export default component.exports